// extracted by mini-css-extract-plugin
module.exports = {"staticText":"_e70cc0a"};